import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import classNames from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { A11YLabel } from '../A11YLabel/A11YLabel.js';
import { base } from '../Button/StyledButton.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["active", "aria-disabled", "aria-label", "children", "className", "disabled", "endAdornment", "hideLabel", "iconSize", "label", "name", "onClick", "startAdornment", "tabIndex", "title", "type", "variant"];
var StyledButton = styled.button.withConfig({
  displayName: "LinkButton__StyledButton",
  componentId: "sc-wlt33e-0"
})(function (_ref) {
  var theme = _ref.theme;
  var _theme$CTAColors = theme.CTAColors,
    primary = _theme$CTAColors.primary,
    primaryVariant = _theme$CTAColors.primaryVariant,
    _theme$neutralColors = theme.neutralColors,
    charcoal = _theme$neutralColors.charcoal,
    rhino = _theme$neutralColors.rhino,
    white = _theme$neutralColors.white;
  return {
    "&&": _objectSpread(_objectSpread({}, base), {}, {
      background: "none",
      borderStyle: "none",
      borderWidth: 0,
      "&.mtlui-primary": {
        color: primary,
        ":hover, :focus, :active, &.mtlui-active": {
          color: primaryVariant,
          textDecoration: "underline"
        }
      },
      "&.mtlui-secondary": {
        color: charcoal,
        "&:hover, :focus, :active, &.mtlui-active": {
          color: primaryVariant,
          textDecoration: "underline"
        }
      },
      "&.mtlui-inverted": {
        color: white,
        "&:hover, :focus, :active, &.mtlui-active": {
          color: primaryVariant,
          textDecoration: "underline"
        }
      },
      "&.mtlui-disabled": {
        color: rhino,
        cursor: "not-allowed",
        ":hover, :focus, :active, &.mtlui-active": {
          color: rhino,
          textDecoration: "none"
        }
      }
    })
  };
});
var LinkButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var active = props.active,
    ariaDisabledBooleanish = props["aria-disabled"],
    ariaLabel = props["aria-label"],
    children = props.children,
    className = props.className,
    disabled = props.disabled,
    endAdornment = props.endAdornment,
    hideLabel = props.hideLabel,
    iconSize = props.iconSize,
    label = props.label;
    props.name;
    var onClick = props.onClick,
    startAdornment = props.startAdornment,
    tabIndex = props.tabIndex;
    props.title;
    var type = props.type,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? "primary" : _props$variant,
    rest = _objectWithoutProperties(props, _excluded);
  var ariaDisabled = ariaDisabledBooleanish === void 0 ? void 0 : (ariaDisabledBooleanish === null || ariaDisabledBooleanish === void 0 ? void 0 : ariaDisabledBooleanish.toString()) === "true";
  var classes = classNames("mtlui-".concat(variant), className, {
    "mtlui-active": disabled ? false : active,
    "mtlui-disabled": disabled || ariaDisabled
  });
  return /*#__PURE__*/jsx(StyledButton, _objectSpread(_objectSpread({
    "aria-disabled": ariaDisabled,
    "aria-label": children ? ariaLabel || label : ariaLabel,
    className: classes,
    disabled: disabled,
    ref: ref,
    tabIndex: disabled ? -1 : tabIndex,
    type: type || "button",
    onClick: ariaDisabled || onClick ? function (e) {
      if (onClick && !ariaDisabled) onClick(e);
    } : void 0
  }, rest), {}, {
    children: children && typeof children !== "string" ? /*#__PURE__*/jsx("span", {
      style: disabled || ariaDisabled ? {
        pointerEvents: "none"
      } : void 0,
      children: children
    }) : /*#__PURE__*/jsx(A11YLabel, {
      endAdornment: endAdornment,
      hideLabel: hideLabel,
      iconSize: iconSize,
      label: children ? children.toString() : label,
      startAdornment: startAdornment
    })
  }));
});
LinkButton.displayName = "LinkButton";

export { LinkButton };
